import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getInitialPhotoCropbox } from '../helpers';

const propTypes = {
  className: PropTypes.string,
  cropbox: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    scale: PropTypes.number.isRequired,
    rotation: PropTypes.number.isRequired,
  }),
  src: PropTypes.string.isRequired,
  isEntitled: PropTypes.bool,
  isForegroundImage: PropTypes.bool,
};

const CardElementPhotoImage = ({
  className,
  cropbox,
  src,
  isEntitled = true,
  isForegroundImage = false,
}) => {
  const classes = classNames({
    'card-element-photo-contain': true,
    [className]: !!className,
  });

  const { x, y, scale, rotation } = cropbox ?? getInitialPhotoCropbox();

  return (
    <div className={classes}>
      <div
        className="card-element-photo-translate"
        style={{
          transform: `translate(${x * 100}%, ${y * 100}%) scale(${scale})`,
        }}
      >
        <div
          className="card-element-photo-image"
          style={{
            transform: `rotate(${rotation}rad)`,
            backgroundImage: `url(${src})`,
          }}
        />
      </div>
      {!isEntitled && !isForegroundImage && (
        <div className="card-element-photo-image-preview-label-watermark is-not-printable" />
      )}
    </div>
  );
};

CardElementPhotoImage.propTypes = propTypes;

export default CardElementPhotoImage;
